import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, AppBar, Toolbar, Link} from 'views/components';
import {translate, Translate} from 'views/module';

const Header = (props) => {
  const {position} = props;

  return (
    <AppBar
      position={position ? position : 'static'}
      elevation={0}
      color="transparent"
      sx={{
        bgcolor: 'transparent',
        color: 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
        width: '100%',
      }}
    >
      <Toolbar disableGutters
        sx={{
          px: '50px',
          py: '10px',
          minHeight: 'unset',
          height: 'min-content',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'relative',
          overflow: 'clip',
        }}>
        {/* Logo */}
        <Box sx={{flex: '0 0 auto'}}>
          <Link
            href="https://carequilt.ca/"
            underline="none"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              mr: 2,
            }}
          >
            <Box
              component="img"
              src="https://framerusercontent.com/images/QL1IFmrzswHBy7240Tqr5F0HWk.png?width=2000&height=368"
              alt={translate('jobBoard.Header.LogoAltText')}
              sx={{
                display: 'block',
                width: 159,
                position: 'relative',
                overflow: 'visible',
                height: 'auto',
                aspectRatio: '5.434782608695652',
                boxSizing: 'border-box',
                flex: 'none',
              }}
            />
          </Link>
        </Box>

        {/* center slot */}
        <Box sx={{flex: '0 0 auto'}} />

        {/* Primary CTA */}
        <Box sx={{flex: '0 0 auto'}}>
          <Button
            component="a"
            href="https://carequilt.ca/landing-page#get-started"
            variant="contained"
            disableElevation
            sx={{
              'fontSize': '14px',
              'width': 'auto',
              'height': 'auto',
              'boxSizing': 'border-box',
              'flex': 'none',
              'position': 'relative',
              'textTransform': 'none',
              'borderRadius': 2,
              'bgcolor': 'rgb(218, 119, 87)',
              '&:hover': {bgcolor: 'rgb(200, 105, 75)'},
            }}
          >
            <Translate expression='jobBoard.Header.FindCareGiver'/>
          </Button>
        </Box>
      </Toolbar>
    </AppBar>

  );
};

Header.propTypes = {
  position: PropTypes.string,
};

export default Header;
